<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Juridinio asmens kodas"
          tooltip="Hipoteka. Turtas. Įmonė. Juridinio asmens kodas"
          :readonly="turtasReadonly || !sudarymas"
          :counter="20"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="12">
        <el-text-field
          label="Pavadinimas"
          tooltip="Hipoteka. Turtas. Įmonė. Pavadinimas"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_imone_pavadinimas"
        />
      </v-col>
      <v-col cols="12" md="12">
        <el-text-field
          label="Buveinės adresas"
          tooltip="Hipoteka. Turtas. Įmonė. Buveinės adresas"
          :readonly="turtasReadonly"
          :counter="256"
          v-model="formData.tur_imone_buveines_adresas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-checkbox
          label="Įkeičiama įmonės dalis"
          tooltip="Hipoteka. Turtas. Įmonė. Įkeičiama dalis įmonės"
          :readonly="readonly"
          v-model="formData.tur_imone_pozymis_dalis"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasImone',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
